<template>
  <v-card 
  :dark="darkTheme ? darkTheme : false"
  elevation="0" 
  max-width="350px"
  height="200px" 
  class="text-center" 
  style="border:1px solid #fff">
    <div style="margin-top:75px!important">
      <a class="view-link" :href="url" :target="'_blank'">
        <v-icon :size="50" color="grey">mdi-play-circle-outline</v-icon>
      </a>
    </div>
  </v-card>
</template>
<script>
export default {
  name: 'GDrivePostView',
  props: [
    'url',
    'darkTheme'
  ],
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {
  }
};
</script>
<style scoped>
  .view-link:hover {
    opacity: 0.8;
  }
</style>



// WEBPACK FOOTER //
// GDrivePostView.vue?5d2bf11a